export type CdnMetadataTableName = `${string}cdn-metadata-table`;
